import { useEffect, useState } from 'react'

const MOBILE_BREAKPOINT = 767

/**
 * Hook centralise pour detecter si l'ecran est en mode mobile (< 768px)
 * Utilise window.matchMedia avec un listener pour reagir aux changements de taille
 */
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches,
  )

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      `(max-width: ${MOBILE_BREAKPOINT}px)`,
    )

    const handleChange = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches)
    }

    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  return isMobile
}
